import { UserRiskFactorsPerCancerDto } from '@/api/generated/model';
import { formatCancerTypeNameWithCapitalization } from '../cancer/types';

export const risksByCancerToSorted = (risks?: UserRiskFactorsPerCancerDto) => {
  return risks
    ? {
        ...risks,
        risks: risks?.factorsPerCancer?.slice().sort((a, b) => {
          // sort overall to top
          if (a.cancerType === 'overall') return -1;
          if (b.cancerType === 'overall') return 1;

          // sort alphabetically
          return formatCancerTypeNameWithCapitalization(a.cancerType).localeCompare(
            formatCancerTypeNameWithCapitalization(b.cancerType)
          );
        }),
      }
    : undefined;
};
